<template>
  <div class="case">
    <div class="case-title">
      <span class="case-title-text">浙江省教育科学研究院附属小学——用AI撬动从"枯桑"到"沃野"的科学教育变革</span>
    </div>
    <div class="case-line"></div>
    <div class="case-main">
      <div class="case-section">
        <p class="case-section__content">
          基于数字化传感器套件搭建多模态数据驱动评价的科学实践课程《解锁桑树种植密码》成功入选《2025智能教育发展蓝皮书》优秀案例。
        </p>
      </div>
      
      <div class="case-images">
        <div class="case-image-placeholder" >
          <img src="@/assets/images/case/case3_1.jpeg" alt="case3-1">
        </div>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">一、当科学课堂遇上"枯死的桑树"</h3>
        <p class="case-section__content">
          浙江省教育科学研究院附属小学坐落在杭州市半山国家森林公园脚下，在满山绿意的衬托下，校园里几株悄然枯萎的桑树，很快吸引了师生们的目光。正苦于学生缺少驱动探究的"真问题"，观察与实验停留在"眼看手摸"，难以点燃他们内心深处的好奇火种，几棵枯死的桑树，成了基于实际问题延伸的项目式探究学习活动的初次尝试。
        </p>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">二、用AI开启"科学侦探"之旅</h3>
        <p class="case-section__content">
          面对"桑树枯死"这一真实现场，教师利用AI项目设计生成工具，一键生成了《解锁桑树种植密码》的完整探究蓝图，学生们则化身"科学侦探"，手持数字化传感器和平板终端，奔赴现场。
        </p>
        <ul class="case-section__list">
          <li class="case-section__list-item">
            <strong>精准化数据采集：</strong>在探究中，学生不再依赖于"土壤有点干"或"阳光不错"等主观感受。他们手持土壤湿度、pH值、光照度、温度、环境湿度等一系列专业传感器，对校园六个区域进行系统性网格化测量。
          </li>
          <li class="case-section__list-item">
            <strong>实时化数据处理：</strong>学生可以使用平板电脑，将传感器采集的数据上传，实时同步到教室大屏。结论的得出完全基于证据，而非猜测，让学生们像真正的科学家一样寻找环境与桑树健康之间的关联。
          </li>
          <li class="case-section__list-item">
            <strong>循证化科学决策：</strong>综合比对pH值、湿度、光照、温度等多维度数据，学生通过本次探究精准地定位"土壤湿度"是当前的关键限制因子，为下一阶段"人工干预对环境的影响"探究提供了清晰的方向。
          </li>
        </ul>
        <div class="case-images">
          <div class="case-image-placeholder">
            <img src="@/assets/images/case/case3_2.png" alt="case3-2">
          </div>
          <div class="case-image-placeholder">
            <img src="@/assets/images/case/case3_3.png" alt="case3-3">
          </div>
          <div class="case-image-placeholder">
            <img src="@/assets/images/case/case3_4.png" alt="case3-4">
          </div>
        </div>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">三、从"一课之变"到"育人生态之变"</h3>
        <p class="case-section__content">
          《解锁桑树种植密码》里不仅有桑树重获新生的希望，更是科学教育破土而出、向阳生长的蓬勃力量。
        </p>
        <ul class="case-section__list">
          <li class="case-section__list-item">
            <strong>教师成长为"设计师"：</strong>张慧老师的案例成功入选国家级《2025智能教育发展蓝皮书》。她感慨道："AI让我创造更多新形式、新内容，未来更有助于引导和激发学生，真正成为学习旅程的设计师。"
          </li>
          <li class="case-section__list-item">
            <strong>学生蜕变为"探索者"：</strong>"我像闯关一样就学完了知识，想问的问题有很多，AI虚拟助教就是我的专属老师！"参加本次实验的学生分享。
          </li>
          <li class="case-section__list-item">
            <strong>学校铸就为"创新场"：</strong>项目从附小的"一堂好课"，升级为省内科学教育创新的"一个范式"，为"AI+科学教育"提供了可复制、可推广的成功样板。
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Case3"
}
</script>
<style lang="scss" scoped>
.case {
  width: 1185px;
  margin: 0 auto;
  background: #FFFFFF;
  padding: 32px;
  
  &-title {
    font-size: 24px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
    color: #262626;
  }
  
  &-line {
    width: 1120px;
    height: 1px;
    margin: 32px auto;
    background: #E5E5E5;
  }
  
  &-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  
  &-images {
    display: flex;
    gap: 20px;
    margin: 16px 0;
    align-items: stretch;
  }
  
  &-image-placeholder {
    flex: 0 0 auto;
    height: 250px;
    min-width: 0;
    background: #F5F5F5;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  
  &-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    &__title {
      font-size: 18px;
      font-weight: 600;
      line-height: 28px;
      color: #262626;
      margin: 0;
    }
    
    &__content {
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0.01em;
      color: #262626;
    }

    &__list {
      margin: 0;
      padding-left: 24px;
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    &__list-item {
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0.01em;
      color: #262626;
      position: relative;
      padding-left: 8px;

      &::before {
        content: "•";
        position: absolute;
        left: -16px;
        color: #3188F6;
        font-weight: bold;
        font-size: 20px;
      }

      strong {
        color: #262626;
        font-weight: 600;
      }
    }
  }
}
</style>

